
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CookiePolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
